import { render } from "./ScrollToTop.vue?vue&type=template&id=1b8a3d1c&scoped=true"
import script from "./ScrollToTop.vue?vue&type=script&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&lang=js"

import "./ScrollToTop.vue?vue&type=style&index=0&id=1b8a3d1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8a3d1c"]])

export default __exports__